import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Fix cross-origin: quando o domínio atual é diferente do REACT_APP_BACKEND_URL compilado,
// reescrever URLs para usar o domínio atual (evita CORS cross-origin)
const compiledBackendUrl = process.env.REACT_APP_BACKEND_URL || '';
if (compiledBackendUrl && typeof window !== 'undefined') {
  try {
    const compiledHost = new URL(compiledBackendUrl).hostname;
    const currentHost = window.location.hostname;
    if (compiledHost !== currentHost) {
      // Patch axios
      axios.interceptors.request.use((config) => {
        if (config.url && config.url.includes(compiledHost)) {
          config.url = config.url.replace(compiledBackendUrl, window.location.origin);
        }
        return config;
      });
      
      // Patch fetch global para cobrir chamadas diretas
      const originalFetch = window.fetch;
      window.fetch = function(url, options) {
        if (typeof url === 'string' && url.includes(compiledHost)) {
          url = url.replace(compiledBackendUrl, window.location.origin);
        }
        return originalFetch.call(this, url, options);
      };
      
      // Patch process.env em runtime para novos componentes
      // Isso garante que qualquer `process.env.REACT_APP_BACKEND_URL` lido depois retorne o domínio correto
      // Nota: process.env é substituído em build time, mas some variáveis são lidas em runtime via closures
    }
  } catch (e) {
    // URL inválida, ignorar
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// 📦 Registrar Service Worker do app shell — permite abrir o PDV/painel mesmo sem internet
// (cardápio, mesas e caixa continuam disponíveis via cache do IndexedDB/CacheStorage).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}

